import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, SelectField, MenuItem, Checkbox } from 'material-ui';
import StepperActions from '../../generic-components/stepper-actions';
import { toLaxTitleCase } from 'titlecase';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import DateUtils from '../../../../utils/date-utils';
import CancellationPolicies from './seasonal-cancellation-policy/cancellation-policies.jsx';
import { anyPass, compose, call, chain, or, not, propOr, always, ifElse, prop, propEq, allPass, any, reject, isEmpty, isNil, either, T, complement, cond, equals } from 'ramda';
const isNilOrEmpty = either(isNil, isEmpty);
const AddProductPolicy = ({
  type,
  onRequestClose,
  onTextFieldChange,
  onTextFieldChangeWithKeyPath,
  contractId,
  productId,
  saveProductInfoChanges,
  data,
  saving,
  existingSeasons,
  contractingPeriod,
  productType,
}) => {
  const toGreaterThanFrom = (fromAge, toAge) => fromAge > toAge ? 'Invalid age range' : '';
  const propForCancellation = {
    existingSeasons,
    onTextFieldChangeWithKeyPath,
    data,
    contractingPeriod,
    productType,
  };
  const ages = [];
  for (let i = 0; i < 22; i++) {
    ages.push(<MenuItem value={i} key={i} primaryText={`${i}`}/>);
  }
  const agesForInfantAndChild = (
    <div>
      <p style={{ float: 'left', margin: '3% 0% 0% 4.7%', fontSize: '14px' }}>From</p>
      <SelectField
        style={{ margin: '4px 0px 20px 10px', width: '23%', float: 'left' }}
        hintText={data.selectedPolicy.policyType === 'child' ? '2' : '0'}
        value={data.selectedPolicy.ageFrom}
        onChange={(event, index, value) => onTextFieldChange({ key: 'ageFrom', value, updateProductPolicy: true })}
        maxHeight={200}
        errorText={data.selectedPolicy.ageTo ? toGreaterThanFrom(data.selectedPolicy.ageFrom, data.selectedPolicy.ageTo) : ''}
      >
      {ages}
      </SelectField>
      <p style={{ float: 'left', margin: '3% 0% 0% 4.5%', fontSize: '14px' }}>To</p>
      <SelectField
        style={{ margin: '4px 0px 20px 10px', width: '23%', float: 'left' }}
        hintText={data.selectedPolicy.policyType === 'child' ? '15' : '1'}
        value={data.selectedPolicy.ageTo}
        onChange={(event, index, value) => onTextFieldChange({ key: 'ageTo', value, updateProductPolicy: true })}
        maxHeight={200}
        errorText={data.selectedPolicy.ageTo ? toGreaterThanFrom(data.selectedPolicy.ageFrom, data.selectedPolicy.ageTo) : ''}
      >
      {ages}
      </SelectField>
      <p style={{ float: 'left', margin: '3% 0% 0% 4.5%', fontSize: '14px' }}>(inclusive)</p>
    </div>
  );
  const { additionalDiv, note, example, textAboveTextField } = (() => {
    const policyType = data.selectedPolicy ? data.selectedPolicy.policyType : '';
    switch (policyType) {
      case 'cancellation':
        return {
          additionalDiv: (
            <CancellationPolicies {...propForCancellation}/>
          ),
          note: 'Your cancellation policy tells your partners when, and how much, they will be charged for cancelling a booking.',
          example: '',
        };
      case 'group':
        return {
          additionalDiv: (<div/>),
          note: 'Please note any special conditions or policies that apply for group bookings. If you have policies for specific seasons, please note them below.',
          example: '',
        };
      case 'family':
        return {
          additionalDiv: (<div>
            <TypeControlledTextField
              controlledType="number"
              style={{ marginLeft: '20px', width: '30%', marginBottom: '20px', float: 'left' }}
              floatingLabelText="Number of Adults"
              floatingLabelStyle={{ fontSize: '12px' }}
              value={data.selectedPolicy.adultCount}
              onChange={({ target: { value } }) => onTextFieldChange({ key: 'adultCount', value, updateProductPolicy: true })}
            />
            <p style={{ float: 'left', margin: '9% 0% 0% 2%', fontSize: '14px' }}>Adults</p>
            <TypeControlledTextField
              controlledType="number"
              style={{ marginLeft: '10px', width: '30%', marginBottom: '20px', float: 'left' }}
              floatingLabelText="Number of Children"
              floatingLabelStyle={{ fontSize: '12px' }}
              value={data.selectedPolicy.childrenCount}
              onChange={({ target: { value } }) => onTextFieldChange({ key: 'childrenCount', value, updateProductPolicy: true })}
            />
            <p style={{ float: 'left', margin: '9% 0% 0% 2%', fontSize: '14px' }}>Children</p>
          </div>),
          cap: 'Family',
          note: 'If you have policies for specific seasons, please note them below.',
          example: 'Ex: Family Policy: 2 Adults and 2 Children.',
        };
      case 'freeOfCharge':
        return {
          additionalDiv: (<div/>),
          note: 'On occasion, your partners will have tour leaders, escorts, or guides accompany a group. Please note any conditions in which they will not be charged as part of the booking. If you have policies for specific seasons, please note them below.',
          example: '',
        };
      case 'child':
        return {
          additionalDiv: (<div style={{ display: 'flex', flexDirection: 'column' }}>
            {agesForInfantAndChild}
            <Checkbox
              checked={Boolean(data.selectedPolicy.focChildrenAllowed)}
              onCheck={() => onTextFieldChange({ key: 'focChildrenAllowed', value: !data.selectedPolicy.focChildrenAllowed, updateProductPolicy: true })}
              style={{ marginLeft: '16px', width: '90%' }}
              label="Children Free of Charge (FOC) when sharing existing bedding with adults"
            />
            <div style={{ display: Boolean(data.selectedPolicy.focChildrenAllowed) ? 'flex' : 'none', alignItems: 'center', marginLeft: '56px' }}>
              <TextField type="number" hintText="Number" id="focChildrenCount" value={data.selectedPolicy.focChildrenCount} style={{ width: '100px' }} onChange={({ target: { value } }) => onTextFieldChange({ key: 'focChildrenCount', value, updateProductPolicy: true })} />
              &nbsp; free children <span style={{ color: 'red' }}> * Required</span>
            </div>
            <br/>
            <Checkbox
              checked={Boolean(data.selectedPolicy.childrenNotAccepted)}
              onCheck={() => onTextFieldChange({ key: 'childrenNotAccepted', value: !data.selectedPolicy.childrenNotAccepted, updateProductPolicy: true })}
              style={{ marginLeft: '16px', width: '90%' }}
              label="Children not accepted"
            />
            <br/>
          </div>),
          note: 'If you have policies for specific seasons, please note them below.',
          textAboveTextField: 'Please note any other conditions related to your Child Policy. For example, if a cot or rollaway is required, you will be charged for the additional bedding.',
        };
      case 'infant':
        return {
          additionalDiv: (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {agesForInfantAndChild}
              <Checkbox
                checked={Boolean(data.selectedPolicy.infantAsOccupant)}
                style={{ marginLeft: '16px', width: '90%' }}
                onCheck={() => onTextFieldChange({ key: 'infantAsOccupant', value: !data.selectedPolicy.infantAsOccupant, updateProductPolicy: true })}
                label="Infant counts as an occupant"
              />
            </div>
          ),
          note: 'If you have policies for specific seasons, please note them below.',
          example: '',
        };
      default:
        return (<div/>);
    }
  })();
  const emptyPolicies = ['group', 'freeOfCharge', 'family', 'child', 'infant'].filter(policyType => {
    return data.productPolicy.every(policy => policy.policyType !== policyType);
  });
  const checkIfShouldDisable = dataInfo => {
    const selectedPolicy = propOr({}, 'selectedPolicy', dataInfo);
    const { policyType, adultCount, childrenCount, ageFrom, ageTo, conditions } = selectedPolicy;
    const cancellations = propOr([{}], 'cancellations', selectedPolicy);
    const isCancellationNotValid = complement(anyPass([
      allPass([
        prop('cancelNum'),
        prop('cancelHoursDays'),
        prop('conditions'),
      ]),
      propEq('conditions', 'Same as location cancellation policy'),
    ]));
    const cancellationsNotValid = () => {
      const allDateRanges = DateUtils.getFlattenedUnEmptyDates(cancellations);
      const seasonCovered = DateUtils.seasonCovered(allDateRanges, contractingPeriod);
      return or(any(isCancellationNotValid, cancellations), not(seasonCovered));
    };
    const familyPolicyNotValid = () => any(isNilOrEmpty, [adultCount, childrenCount]);
    const infantPolicyNotValid = () => any(isNilOrEmpty, [ageFrom, ageTo]);
    const childPolicyNotValid = () => call(anyPass([
      () => (ageFrom == null || ageFrom === false) || (ageTo == null || ageTo === false), // == includes undefined check
      () => selectedPolicy.focChildrenAllowed && !selectedPolicy.focChildrenCount,
    ]));
    return call(cond([
      [equals('cancellation'), cancellationsNotValid],
      [equals('family'), familyPolicyNotValid],
      [equals('child'), childPolicyNotValid],
      [equals('infant'), infantPolicyNotValid],
      [T, () => !conditions],
    ]), policyType);
  };
  const shouldDisable = checkIfShouldDisable(data);

  return (
    <div style={{ padding: '16px', minHeight: '250px' }}>
      <div>
      {
        emptyPolicies.length < 1 || equals(type, 'editProductPolicy') || data.selectedPolicy.policyType === 'cancellation' ? <div/> : (
          <SelectField
            style={{ width: '90%', marginLeft: '20px' }}
            floatingLabelText="Please select the type of policy you want to add"
            floatingLabelStyle={{ color: '#00bcd4' }}
            value={data.selectedPolicy.policyType}
            onChange={(e, _, value) => onTextFieldChange({ key: 'policyType', value, updateProductPolicy: true })}
          >
            {
              emptyPolicies.map((policyType, index) => {
                const primaryText = policyType === 'freeOfCharge' ? 'Free of Charge Policy' : `${toLaxTitleCase(policyType)} Policy`;
                return <MenuItem value={policyType} key={index} primaryText={primaryText} />;
              })
            }
          </SelectField>
        )
      }

      {
        data.selectedPolicy.policyType ? (
          <div style={{ fontSize: '12px' }}>
            <div style={{ width: '90%', margin: '16px 16px 0 16px' }}>{note}</div>
            {additionalDiv}
            <i style={{ marginLeft: '20px', float: 'left', width: '90%', fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)' }}>{textAboveTextField}</i>
            {
              data.selectedPolicy.policyType !== 'cancellation' ? <TextField
                id="product policy conditions"
                style={{ marginLeft: '20px', width: '90%', marginBottom: '20px' }}
                defaultValue={data.selectedPolicy.conditions}
                hintText={example}
                multiLine
                rowsMax={4}
                onChange={({ target: { value } }) => onTextFieldChange({ key: 'conditions', value, updateProductPolicy: true })}
              /> : ''
            }
          </div>
        ) : undefined
      }
      </div>
      <StepperActions rightButtons={
        <div style={{ marginTop: Object.keys(data.selectedPolicy).length ? '' : '150px' }}>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => saveProductInfoChanges({
              contractId,
              productId,
              data,
              updateType: call(ifElse(
                equals('editProductPolicy'),
                  always('SAVED_EDITED_PRODUCT_POLICY'),
                always('SAVED_PRODUCT_POLICY')
              ), type) })
            }
            secondary
            disabled={shouldDisable}
          />
        </div>
        }
      />
    </div>
  );
};

AddProductPolicy.propTypes = {
  onRequestClose: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  saveProductInfoChanges: PropTypes.func,
  data: PropTypes.object,
  saving: PropTypes.bool,
};
const mapStateToProps = ({ contracting }) => ({
  type: contracting.addEditContractDialog.get('type'),
});

export default connect(mapStateToProps)(AddProductPolicy);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/add-product-policy.jsx